var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { padding: "40px 16px", "background-color": "#101010" } },
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c("span", { staticClass: "title-text text400" }, [
          _vm._v("Still have")
        ])
      ]),
      _vm._v(" "),
      _c("el-col", { attrs: { span: 24 } }, [
        _c("span", { staticClass: "title-text text600" }, [
          _vm._v("questions?")
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-col",
        {
          staticStyle: {
            "margin-top": "40px",
            display: "flex",
            "flex-direction": "column"
          },
          attrs: { span: 24 }
        },
        [
          _c(
            "el-button",
            {
              staticClass: "ua-primary-btn",
              on: { click: _vm.redirectToHelpCenter }
            },
            [_vm._v("\n      Help Center\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d3a1f4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d3a1f4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/gotQuestions.vue
// module id = null
// module chunks = 